/**
 * AppRouter extension which enables the use of roles in protecting routes
 */

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var PermissionAppRouter = Marionette.AppRouter.extend({
  onRoute: function (name, path, params) {
    // when there are no permissions set, ignore this bit
    if (!this.allowedRoles) return
    if (this.allowedRoles.length <= 0) return

    var allowedRoles = this.allowedRoles[path]

    if (!App.session.user.hasRole(allowedRoles)) {
      console.warn('Oops.. You don\'t have access to the "' + path + '" page.')
      history.go(-1)
    }
    return false
  }
})

module.exports = PermissionAppRouter



// WEBPACK FOOTER //
// ./js/common/permission-app-router.js